import { useState } from 'react';
import { Body1Strong, Link as FluentLink } from '@fluentui/react-components';

export const ChangeNoteRow = ({ note }: { note: string }) => {
  const [showNote, setShowNote] = useState(false);
  return (
    <div>
      <p className="flex">
        <span className="block w-32 flex-shrink-0">
          {showNote ? <Body1Strong>Change note:</Body1Strong> : 'Change note:'}
        </span>
        <FluentLink onClick={() => setShowNote(!showNote)}>{showNote ? 'Hide' : 'Show'}</FluentLink>
      </p>
      {showNote && <p className="mt-1.5 whitespace-break-spaces break-words">{note}</p>}
    </div>
  );
};
